
import { ScrollArea } from "@/components/ui/scroll-area";

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <ScrollArea className="h-[calc(100vh-8rem)] rounded-md border p-8">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
          <p className="text-sm text-muted-foreground mb-4">
            Effective Date: February 2, 2025<br />
            Last Updated: February 2, 2025
          </p>

          <h2 className="text-2xl font-semibold mt-8">1. Introduction</h2>
          <p>
            These Terms of Service ("Terms") govern your use of <strong>www.tryposit.com</strong> ("Posit"). By accessing or using Posit, you agree to these Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8">2. Use of Posit</h2>
          <ul>
            <li>You must be at least <strong>18 years old</strong> or have parental consent to use Posit.</li>
            <li>You are responsible for any content you provide to Posit.</li>
            <li>We do not allow illegal, harmful, or offensive content.</li>
            <li>Users must comply with applicable laws and refrain from misusing the AI for fraudulent or misleading purposes.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">3. AI Processing & Limitations</h2>
          <ul>
            <li>Posit leverages <strong>OpenAI's API</strong> to generate AI-driven content.</li>
            <li>AI responses may be inaccurate, and Posit does not guarantee factual accuracy.</li>
            <li>Users should independently verify AI-generated insights before relying on them, especially for critical areas such as legal, financial, or medical decisions.</li>
            <li>AI interactions should not be used for critical decision-making processes.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">4. Subscriptions, Payments & Fair Use Policy</h2>
          <ul>
            <li>Payments are processed via <strong>Stripe</strong>.</li>
            <li>Subscription prices are <strong>subject to change</strong> with at least <strong>30 days' prior notice</strong>.</li>
            <li>Refunds are <strong>not guaranteed</strong> but may be reviewed on a case-by-case basis.</li>
            <li>Failed payments may result in suspension or termination of services.</li>
            <li>Some plans may offer <strong>"unlimited"</strong> usage, but usage must remain fair, reasonable, and within typical patterns of individual use.</li>
            <li><strong>Unlimited*</strong> usage is subject to <strong>fair use</strong> and <strong>technical rate limits</strong> to ensure platform stability for all users.</li>
            <li>Fair Use Policy: If a user's usage significantly exceeds the average consumption of similarly situated users, we reserve the right to throttle, limit, or suspend access to maintain service integrity.</li>
            <li>Rate Limits:</li>
            <ul>
              <li>Free users may be subject to usage caps, rate limits, or throttling to prevent excessive load.</li>
              <li>Paid users may receive higher or no rate limits, but excessive automated queries or unusual traffic patterns may still be restricted.</li>
            </ul>
            <li>We reserve the right to adjust rate limits and fair use policies at any time to ensure service availability for all users.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">5. Account Termination</h2>
          <ul>
            <li>We reserve the right to suspend or terminate accounts violating these Terms.</li>
            <li>Users are responsible for safeguarding their accounts against unauthorized access.</li>
            <li>You may delete your account by contacting <strong>posit-support@tryposit.com</strong>.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">6. Privacy & Data Usage</h2>
          <ul>
            <li>Our <strong>Privacy Policy</strong> governs data collection and usage.</li>
            <li>We may use cookies and tracking technologies for analytics and marketing.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">7. Limitation of Liability</h2>
          <ul>
            <li>Posit is provided "as is" without warranties.</li>
            <li>We are <strong>not liable</strong> for any damages resulting from use or inability to use the service.</li>
            <li>Users assume full responsibility for their use of AI-generated content.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">8. Dispute Resolution & Jurisdiction</h2>
          <ul>
            <li>Disputes will be resolved through <strong>binding arbitration</strong> using the <strong>American Arbitration Association (AAA)</strong>.</li>
            <li>Users waive rights to class-action lawsuits.</li>
            <li>Legal disputes will be governed by <strong>the laws of the State of Delaware, United States</strong>.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">9. Modifications to These Terms</h2>
          <ul>
            <li>We may update these Terms at any time.</li>
            <li>Continued use of Posit after changes constitutes acceptance of the new Terms.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">10. Contact Information</h2>
          <p>
            For questions or concerns, email <strong>posit-support@tryposit.com</strong>.
          </p>

          <p className="mt-8">
            By using Posit, you acknowledge that you have read and agreed to this Privacy Policy and Terms of Service.
          </p>
        </div>
      </ScrollArea>
    </div>
  );
};

export default Terms;

